import { LanguageContext } from '../createRules';

export const LanguageWrapper = ({ obj, children }) => (
  <LanguageContext.Provider value={obj.data.get('lang')}>
    {children}
  </LanguageContext.Provider>
);
